import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import "../Styles/index.css";
import "./IntranetRedTheme.css";

import ForosUsuario from "./usuario/ForosUsuario";

export default function IntranetUsuarioForosPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialItem = location.state?.initialItem;

  return (
    <div className="intranet-red-theme">
      <ForosUsuario
        onVolver={() => navigate("/menu/intranet/usuario")}
        initialItem={initialItem}
      />
    </div>
  );
}
